// @flow
import * as React from 'react';
import ProductGroupCard from 'app/common/react/components/profile/ProductGroupCard/ProductGroupCard';

type Props = {|
  layout?: 'square' | 'wide',
  productGroup: Object,
|};

export default function ProductGroupCardWithImpressions({ layout, productGroup }: Props) {
  return <ProductGroupCard layout={layout} productGroup={productGroup} />;
}
